export const TOOLS = [
	{
		id: 'career',
		icon: '🧭',
		title: 'Career Finder',
		stats: ['9,000+ jobs', 'Skills matched'],
		description:
			'Find upcoming careers and the skills required in a student’s dream country.',
		action: 'Explore careers',
		enabled: true,
	},
	{
		id: 'country',
		icon: '🌍',
		title: 'Country Finder',
		stats: ['Immigration data', 'Visa info'],
		description:
			'Match the right country based on careers, visas, cost and lifestyle.',
		action: 'Explore countries',
		enabled: true,
	},
	{
		id: 'course',
		icon: '📚',
		title: 'Course Finder',
		stats: ['800+ options', 'Career-based'],
		description:
			'Find specialisations aligned to a student’s career goals and future scope.',
		action: 'Explore courses',
		enabled: true,
	},
	{
		id: 'college',
		icon: '🎓',
		title: 'College Shortlister',
		stats: ['1,500 colleges', 'Deadlines'],
		description:
			'Build an accurate shortlist based on marks, goals and country rules.',
		action: 'Explore universities',
		enabled: true,
	},
]

// Order is fixed for every journey type; only the active step changes.
export const AI_TOOL_STEPS = [
	{ id: 'career', label: 'Career' },
	{ id: 'country', label: 'Country' },
	{ id: 'course', label: 'Course' },
	{ id: 'college', label: 'College' },
]

export const getStudentName = student =>
	student?.name || student?.fullName || student?.studentName || 'Student'

const FINDER_PRIORITY = {
	country: ['country', 'career', 'course', 'college'],
	career: ['career', 'country', 'course', 'college'],
	course: ['course', 'career', 'country', 'college'],
	college: ['college', 'career', 'country', 'course'],
}

/** Four finder steps for saved-journey cards (no wishlist/applications). */
export function getSortedFinderSteps(typeFlow = 'career') {
	return FINDER_PRIORITY[typeFlow] || FINDER_PRIORITY.career
}

export function getFinderToolIcon(finderId) {
	return TOOLS.find(tool => tool.id === finderId)?.icon ?? null
}

export function getFinderToolTitle(finderId) {
	return TOOLS.find(tool => tool.id === finderId)?.title ?? finderId
}
